import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { countriesWithoutTaxFreeZones, Country, countryAlpha2ToAlpha3, countryIsoCodes } from '~/types/country';

export const useCountries = (includeTaxFreeZones = false): Country[] => {
  const { t } = useTranslation('countries');

  const codesToUse = includeTaxFreeZones ? countryIsoCodes : countriesWithoutTaxFreeZones;

  const countriesWithData = useMemo(
    () =>
      sortBy(
        codesToUse.map((code) => ({
          code,
          cca3: countryAlpha2ToAlpha3[code],
          flagCode: code === 'OO' ? 'it' : code.toLowerCase(),
          name: t(code),
        })),
        (country) => country.name,
      ),
    [codesToUse, t],
  );

  return countriesWithData;
};
